import { createServerColumnHelper } from '../../shared-compat/DataTable/hooks';

export type BypassTableRow = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  BypassId: number;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  Company: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  Site: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  RmxAssetId: string; // -1 if not an asset

  // eslint-disable-next-line @typescript-eslint/naming-convention
  RmxSiteId: string; // -1 if not a site

  // eslint-disable-next-line @typescript-eslint/naming-convention
  RmxBoxId: string; // -1 if not a box

  // eslint-disable-next-line @typescript-eslint/naming-convention
  SiteUuid: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  Contacts: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  AssetSystem: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  ModelNumber: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  SerialNumber: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  ExpDate: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  CreatedBy: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  CreatedAt: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  BypassAction: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  BypassType: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  Reason: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  SystemProcessId: string; // -1 if not a system process
};

const helper = createServerColumnHelper<BypassTableRow>();
const ch = helper.accessor;

export const bypassColumnDef = () =>
  [
    // ch('Id', 'number', {
    //   header: 'Id',
    //   enableSorting: true,
    //   sortDescFirst: false,
    //   enableColumnFilter: true,
    //   cell: (info) => {
    //     return info.getValue();
    //   },
    //   footer: (props) => props.column.id
    // }),
    ch('Company', 'string', {
      header: 'Company',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('Site', 'string', {
      header: 'Site',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('AssetSystem', 'string', {
      header: 'Asset/System',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('ModelNumber', 'string', {
      header: 'Model Number',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('SerialNumber', 'string', {
      header: 'Serial Number',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('ExpDate', 'string', {
      header: 'Exp Date',
      enableSorting: true,
      sortDescFirst: false,
      enableColumnFilter: true,
      cell: (info) => {
        const expDate = info.getValue();
        return expDate;
      },
      footer: (props) => props.column.id
    }),
    ch('CreatedBy', 'string', {
      header: 'Created By',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('CreatedAt', 'string', {
      header: 'Created At',
      enableSorting: true,
      sortDescFirst: false,
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('BypassAction', 'string', {
      header: 'Bypass Action',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    }),
    ch('Reason', 'string', {
      header: 'Reason',
      enableColumnFilter: true,
      cell: (info) => {
        return info.getValue();
      },
      footer: (props) => props.column.id,
      meta: {
        serverFilters: ['exact-text']
      }
    })
  ] as const;
